"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  textEditorContent: {
    border: '1px solid black',
    background: '#FFF',
    color: '#000'
  },
  selectionToolboxContainer: {
    position: 'fixed',
    bottom: 0
  }
};